import React, { useEffect, useState } from "react";
// import TeenPatti from "../../../Web/TeenPatti.png";
import User1 from "../../../Web/1.png";
import User2 from "../../../Web/2.png";
import User3 from "../../../Web/3.png";
import User4 from "../../../Web/4.png";
import Winner_1 from "../../../New_Web_design/1_winner_icon.png";
import Winner_2 from "../../../New_Web_design/2_winner_icon.png";
import Winner_3 from "../../../New_Web_design/3_winner_icon.png";
import TicTacToe from "../../../New_Web_design/Tic_Tac_Toe_logo.png";
import Block_Blast_logo from "../../../New_Web_design/Block_Blast_logo.png";
// import Candy_Cream_logo_old from "../../../New_Web_design/Candy_Cream_logo_old.png";
import Candy_Cream_logo from "../../../New_Web_design/Candy_Cream_logo.png";
import Poker_logo from "../../../New_Web_design/Poker_logo.png";
import Chess_logo from "../../../New_Web_design/Chess_logo.png";
import Eight_ball_pool_logo from "../../../New_Web_design/8_ball_pool_logo.png";
import Logic_Line_logo from "../../../New_Web_design/Logic_Line_logo.png";
import Word_Book_logo from "../../../New_Web_design/Word_Book_logo.png";
import Smash_Block_logo from "../../../New_Web_design/Smash_Block_logo.png";
import Number_Puzzle_2248_logo from "../../../New_Web_design/Number_Puzzle_2248_logo.png";
import Coin from "../../../Img/Wolfwin_Coin.png";
import img_1 from "../../../New_Web_design/img_1.png";
import img_2 from "../../../New_Web_design/img_2.png";

import img_3 from "../../../New_Web_design/img_3.png";

import img_5 from "../../../New_Web_design/img_5.png";

import img_6 from "../../../New_Web_design/img_6.png";

import Slider from "react-slick";

export default function Games() {
  const [scrollValue, setSrollValue] = React.useState();

  const [gameList] = useState([
    {
      image: Candy_Cream_logo,
      gameName: "Candy Cream",
    },
    {
      image: Number_Puzzle_2248_logo,
      gameName: "Number Puzzle 2248",
    },
    {
      image: Word_Book_logo,
      gameName: "Word Book",
    },
    {
      image: Logic_Line_logo,
      gameName: "Logic Line",
    },
    {
      image: Block_Blast_logo,
      gameName: "Block Blast",
    },
    {
      image: Smash_Block_logo,
      gameName: "Smash Block",
    },
    {
      image: TicTacToe,
      gameName: "Tic Tac Toe",
    },
    {
      image: Poker_logo,
      gameName: "Poker",
    },
    {
      image: Chess_logo,
      gameName: "Chess",
    },
    {
      image: Eight_ball_pool_logo,
      gameName: "8 Ball Pool",
    },
  ]);
  const handleScroll = () => {
    const scrollPosition = window.innerWidth;
    setSrollValue(scrollPosition);
  };
  console.log("width:::::::>", scrollValue);
  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  var settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,

          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1008,
        settings: {
          slidesToShow: 2,

          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,

          slidesToScroll: 1,
        },
      },
    ],
  };
  const [feedbackData] = React.useState([
    {
      img: img_1,
      name: "John D.",
      desc: "WolfWin is my go-to platform for gaming now because being able to win real money prize gives me a sense of purpose and feels like worth my time. Highly recommended!",
    },
    {
      img: img_2,
      name: "Taylor H.",
      desc: "Love it! I can't get enough of WolfWin! The thrill of competing against other players and the chance to win cash prizes keeps me hooked. Also, customer support is quick, it makes WolfWin stand out from the rest.",
    },
    {
      img: img_3,
      name: "Jessica K.",
      desc: "Before WolfWin, I've never experienced such a satisfying game. I always felt guilty of wasting my time playing games with no real-world implications.Now, playing WolfWin and the opportunity to win real cash make it worthwhile to invest my time!",
    },
    {
      img: img_5,
      name: "Emily W.",
      desc: "Withdrawal of money is quick and simple at WolfWin, so much better than any other games I've tried. Also, I just recently noticed that WolfWin’s data security is one of the stringent measures rarely seen. Highly recommend it!",
    },
    {
      img: img_6,
      name: "Rahul K.",
      desc: "I don’t know, but somehow WolfWin games stand out from competitions because of simple convenient features such as quick withdrawal of money, simple interactive design, entry fee & the winning prize is clearly stated exactly, and competition feels fair as well. So it’s more like simple and elegant!",
    },
  ]);

  return (
    <div>
      <div style={{ backgroundColor: "#050810" }} className="p-3 mt-5">
        <div
          className="d-flex "
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            className="header mb-0 text-center"
            style={{
              fontFamily: "NunitoBlack",
              color: "white",
              zIndex: 1,
            }}
          >
            WolfW<span class="i">i</span>n Skill Based Games
          </p>
        </div>
        <div
          className="d-flex"
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            className="sub-header text-center"
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
            }}
          >
            Level up your bank account with skill
          </p>
        </div>
      </div>
      {scrollValue <= 1400 ? (
        <>
          <div class="container mt-4 px-5">
            <Slider {...settings}>
              {gameList.map((item) => {
                return (
                  <>
                    <div className="contentContainer">
                      <div>
                        <img
                          alt="item_image"
                          src={item.image}
                          height="200px"
                          width="200px"
                        />
                        <p
                          style={{
                            color: "white",
                            fontSize: "20px",
                            fontFamily: "JosefinSans",
                          }}
                          className="text-center mt-3"
                        >
                          <b>{item.gameName}</b>
                        </p>
                      </div>
                    </div>
                  </>
                );
              })}
            </Slider>
          </div>
        </>
      ) : (
        <>
          <div
            className=""
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="row container d-flex mb-5"
              style={{ justifyContent: "center", width: "100%" }}
            >
              {gameList?.slice(0, 5).map((item) => {
                return (
                  <>
                    <div
                      className="col-md-4 col-sm-12 col-lg-2 mt-4 px-lg-2 gx-5 "
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div>
                        <img
                          alt="item_image"
                          src={item.image}
                          height="200px"
                          width="200px"
                        />
                        <p
                          style={{
                            color: "white",
                            fontSize: "20px",
                            fontFamily: "JosefinSans",
                          }}
                          className="text-center mt-3"
                        >
                          <b>{item.gameName}</b>
                        </p>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div
            className=""
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="row container d-flex mb-5"
              style={{ justifyContent: "center", width: "100%" }}
            >
              {gameList?.slice(5, 10).map((item) => {
                return (
                  <>
                    <div
                      className="col-md-4 col-sm-12 col-lg-2 mt-4 px-lg-2 gx-5 "
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div>
                        <img
                          alt="item_image"
                          src={item.image}
                          height="200px"
                          width="200px"
                        />
                        <p
                          style={{
                            color: "white",
                            fontSize: "20px",
                            fontFamily: "JosefinSans",
                          }}
                          className="text-center mt-3"
                        >
                          <b>{item.gameName}</b>
                        </p>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          {/* <div
            className=""
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="row container d-flex mb-5"
              style={{ justifyContent: "center", width: "100%" }}
            >
              {gameList?.slice(9, 11).map((item) => {
                return (
                  <>
                    <div
                      className="col-md-4 col-sm-12 col-lg-2 mt-4 px-lg-2 gx-5 "
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div>
                        <img src={item.image} height="200px" width="200px" />
                        <p
                          style={{
                            color: "white",
                            fontSize: "20px",
                            fontFamily: "JosefinSans",
                          }}
                          className="text-center mt-3"
                        >
                          <b>{item.gameName}</b>
                        </p>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div> */}
        </>
      )}

      {/* feedback components */}
      <div className="container mt-4">
        <div
          className="d-flex "
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            className="header mb-0 text-center"
            style={{
              fontFamily: "NunitoBlack",
              color: "white",
              zIndex: 1,
            }}
          >
            Experience
          </p>
        </div>
        <div
          className="d-flex"
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            className="sub-header text-center"
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
            }}
          >
            WolfWin Players
          </p>
        </div>
        <div class="row text-center" style={{ justifyContent: "center" }}>
          {feedbackData?.map((item) => (
            <>
              <div class="col-lg-4  col-md-4 col-sm-12 mt-5 ">
                <div
                  class="card "
                  style={{
                    width: "100%",
                    height: "90%",
                    background: "transparent",
                    border: "3px solid #929498",
                    borderRadius: "40px",
                  }}
                >
                  <img class="card-img-top" src={item.img} alt="card-img-top" />
                  <div
                    class="card-block p-3"
                    style={{ width: "100%", marginTop: "60px" }}
                  >
                    <div className="text-center">
                      <p
                        className="mb-0"
                        style={{
                          fontFamily: "NunitoBlack",
                          fontSize: "20px",
                          color: "#f9c130",
                        }}
                      >
                        {item.name}
                      </p>
                      <p
                        style={{
                          color: "#929498",
                          fontFamily: "JosefinSans",
                        }}
                      >
                        "{item.desc}"
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
      <div className="container my-5" id="win">
        <p
          style={{
            color: "#929498",
            fontFamily: "JosefinSans",
            //   fontSize: "15px",
            textAlign: "center",
          }}
          className="mt-3 fs-5"
        >
          <b>
            WolfWin welcomes you to a world where skill is your currency.
            Immerse yourself in captivating games, stake a nominal entry fee,
            and embark on a quest for extraordinary Reward. Embrace the
            exhilaration of real-time competition and embark on a gaming
            adventure like no other.
          </b>
        </p>
      </div>

      <div style={{ backgroundColor: "#050810" }} className="p-3 mt-5">
        <div
          className="d-flex mt-4"
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            className="header mb-0"
            style={{
              fontFamily: "NunitoBlack",

              color: "white",
            }}
          >
            Winner
          </p>
        </div>
        <div
          className="d-flex"
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            className="sub-header"
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
            }}
          >
            Top 5 WolfWin Winners
          </p>
        </div>
        <div class="container mt-4">
          <div class="row ">
            {/* <div class="col-md-6 col-sm-12 col-lg-6 mt-2 ">
              <div
                style={{
                  backgroundColor: "#0a0d16",
                  borderRadius: "10px",
                }}
              >
                
                <div className="p-3">
                  
                  <table
                    width="100%"
                    className=""
                    style={{ color: "white", position: "relative" }}
                  >
                    <tr>
                      <img
                        src={Winner_1}
                        height="30px"
                        width="30px"
                        className="ms-1 imgTopKingLogo"
                        style={{
                          position: "absolute",
                          top: "-10px",
                          right: "10px",
                        }}
                      />

                      <td
                        height="68px"
                        width="68px"
                        style={{
                          backgroundColor: "#ed864c",
                          borderRadius: "50%",
                        }}
                      >
                        <img src={User1} height="65px" width="65px" />
                      </td>
                      <td className="px-4 m-0">
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          Himli Jone
                        </b>
                      </td>
                      <td>
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                      <div style={ {
                            display: "flex",
                            alignItems: "center"
                          } }>
                            <img className="mx-1" src={ Coin } height={ 20 } />10
                          </div>
                        </b>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div> */}
            <div class="col-md-6 col-sm-12 col-lg-6 mt-2">
              <div
                style={{
                  backgroundColor: "#0a0d16",
                  borderRadius: "10px",
                }}
              >
                <div className="p-3">
                  <table
                    width="100%"
                    className=""
                    style={{ color: "white", position: "relative" }}
                  >
                    <tr>
                      <img
                        alt="Winner_1"
                        src={Winner_1}
                        height="30px"
                        width="30px"
                        className="ms-1 imgTopKingLogo"
                        style={{
                          position: "absolute",
                          top: "-10px",
                          right: "10px",
                        }}
                      />
                      <td
                        height="68px"
                        width="68px"
                        style={{
                          backgroundColor: "#ed864c",
                          borderRadius: "50%",
                        }}
                      >
                        <img
                          alt="User1"
                          src={User1}
                          height="65px"
                          width="65px"
                          style={{
                            position: "absolute",
                            top: "1px",
                            left: "1.5px",
                          }}
                        />
                      </td>
                      <td className="px-4">
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          Aria Mitchell
                        </b>
                      </td>
                      <td>
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              alt="Coin"
                              className="mx-1"
                              src={Coin}
                              height={20}
                            />
                            3.1M
                          </div>
                        </b>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-lg-6 mt-2">
              <div
                style={{
                  backgroundColor: "#0a0d16",
                  borderRadius: "10px",
                }}
              >
                <div className="p-3">
                  <table
                    width="100%"
                    className=""
                    style={{ color: "white", position: "relative" }}
                  >
                    <tr>
                      <img
                        alt="Winner_2"
                        src={Winner_2}
                        height="30px"
                        width="30px"
                        className="ms-1 imgTopKingLogo"
                        style={{
                          position: "absolute",
                          top: "-10px",
                          right: "10px",
                        }}
                      />
                      <td
                        height="68px"
                        width="68px"
                        style={{
                          backgroundColor: "#ed864c",
                          borderRadius: "50%",
                        }}
                      >
                        <img
                          alt="User2"
                          src={User2}
                          height="65px"
                          width="65px"
                          style={{
                            position: "absolute",
                            top: "0.5px",
                            left: "1.5px",
                          }}
                        />
                      </td>
                      <td className="px-4">
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          Isla Reynolds
                        </b>
                      </td>
                      <td>
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              alt="Coin"
                              className="mx-1"
                              src={Coin}
                              height={20}
                            />
                            1.3M
                          </div>
                        </b>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <div class="col-md-6 col-sm-12 col-lg-6 mt-2">
              <div
                style={{
                  backgroundColor: "#0a0d16",
                  borderRadius: "10px",
                }}
              >
                <div className="p-3">
                  <table
                    width="100%"
                    className=""
                    style={{ color: "white", position: "relative" }}
                  >
                    <tr>
                      <td
                        height="68px"
                        width="68px"
                        style={{
                          backgroundColor: "#ed864c",
                          borderRadius: "50%",
                        }}
                      >
                        <img
                          alt="Winner_3"
                          src={Winner_3}
                          height="30px"
                          width="30px"
                          className="ms-1 imgTopKingLogo"
                          style={{
                            position: "absolute",
                            top: "-10px",
                            right: "10px",
                          }}
                        />
                        <img
                          alt="User3"
                          src={User3}
                          height="65px"
                          width="65px"
                          style={{
                            position: "absolute",
                            top: "0.5px",
                            left: "1.5px",
                          }}
                        />
                      </td>
                      <td className="px-4">
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          Maya Patel
                        </b>
                      </td>
                      <td>
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              alt="Coin"
                              className="mx-1"
                              src={Coin}
                              height={20}
                            />
                            99.3K
                          </div>
                        </b>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row ">
            <div class="col-md-6 col-sm-12 col-lg-6 mt-2">
              <div
                style={{
                  backgroundColor: "#0a0d16",
                  borderRadius: "10px",
                }}
              >
                <div className="p-3">
                  <table width="100%" className="" style={{ color: "white" }}>
                    <tr>
                      <td height="68px" width="68px">
                        <img
                          alt="User4"
                          src={User4}
                          height="68px"
                          width="68px"
                        />
                      </td>
                      <td className="px-4">
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          Natalia Silva
                        </b>
                      </td>
                      <td className="px-4">
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                            }}
                          >
                            <img
                              alt="Coin"
                              className="mx-1"
                              src={Coin}
                              height={20}
                            />
                            34K
                          </div>
                        </b>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-lg-6 mt-2">
              <div
                style={{
                  backgroundColor: "#0a0d16",
                  borderRadius: "10px",
                }}
              >
                <div className="p-3">
                  <table width="100%" className="" style={{ color: "white" }}>
                    <tr>
                      <td height="68px" width="68px">
                        <img
                          alt="Coin"
                          src={User2}
                          height="65px"
                          width="65px"
                        />
                      </td>
                      <td className="px-4">
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          Emilia Santos
                        </b>
                      </td>
                      <td
                        className="text-center "
                        style={{ paddingRight: "38px" }}
                      >
                        <b
                          style={{
                            fontFamily: "NunitoBlack",
                            fontSize: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            <img
                              alt="Coin"
                              className="mx-1"
                              src={Coin}
                              height={20}
                            />
                            18K
                          </div>
                        </b>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
